export default __webpack_public_path__ + "static/Upbank-c8e621f3e2613d8f7cd059735db6b8c7.jpg";